import React, { useEffect, useRef, useState } from "react";
import "../styles/BusinessHibHeader.css";
import HeaderIcon from "../icons/BusinessHub/HeaderIcon";
import SettingsIcon from "../icons/BusinessHub/SettingsIcon.js";
import companyController from "../controllers/companyController.js";
import { userService } from "../services/userService.js";
import Utils from "../utils/Utils";
import { EncryptStorage } from "encrypt-storage";
import ArrowDownIcon from "../icons/BusinessHub/ArrowDownIcon.js";
import { useLocation, useNavigate } from "react-router-dom";
import BusinessHubNavigation from "./BusinessHubNavigation.js";
import ThreeLinesMenuIcon from "../icons/BusinessHub/ThreeLinesMenuIcon.js";
import { getActiveKeyForPath } from "../utils/businessHubRoutes.js";

function BusinessHibHeader() {
  const [openNav, setopenNav] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = userService.getUser();
    if (!token) {
      navigate("/", { replace: true });
    }
  }, []);
  const encryptStorage1 = new EncryptStorage("secret-key1", {
    prefix: "@instance1",
  });

  const encryptStorage3 = new EncryptStorage("secret-key3", {
    prefix: "@instance3",
  });
  const encryptStorage4 = new EncryptStorage("secret-key4", {
    prefix: "@instance4",
  });
  const encryptStorage6 = new EncryptStorage("secret-key6", {
    prefix: "@instance6",
  });
  const [comps, setcomps] = useState([]);
  const Authorization = userService.getUser();
  const parsed = Authorization ? Utils.parseJwt(Authorization) : {};
  const userId = Utils.getUserIdFromJwt(parsed);
  const [compname, setcompname] = useState("");
  const dropdownRef = useRef(null);
  const dropmenuRef = useRef(null);

  const [navbaropen, setnavbaropen] = useState(false);
  useEffect(() => {
    const getPrimaryComp = async () => {
      if (!Authorization || !userId) return;
      const getdata = await companyController.userPrimaryCompanies({
        Authorization: Authorization,
        userId: userId,
      });
      if (!Array.isArray(getdata?.data) || getdata.data.length === 0) return;

      // encryptStorage3.setItem("user-azalea", getdata.data[0].companyID);

      setcomps(getdata.data);
    };
    getPrimaryComp();

    return;
  }, [Authorization, userId]);
  /***************************************** */
  useEffect(() => {
    const onClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setnavbaropen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);
  useEffect(() => {
    const onClickOutside = (e) => {
      if (dropmenuRef.current && !dropmenuRef.current.contains(e.target)) {
        setopenNav(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);
  useEffect(() => {
    if (!Array.isArray(comps) || comps.length === 0) return;
    try {
      const stored = userService.getCompID();
      if (!stored) return;

      const storedCompID =
        typeof stored === "string"
          ? stored
          : stored?.companyId || stored?.companyID;

      if (!storedCompID) {
        console.warn("No companyID found in storage:", stored);
        return;
      }
      const foundComp = comps.find(
        (c) => String(c.companyID) === String(storedCompID),
      );
      if (!foundComp) {
        console.warn("Company not found for:", storedCompID);
        return;
      }
      setcompname(foundComp.companyName);
      encryptStorage6.setItem("comp-azalea", foundComp.companyName);
      const savedBPID = encryptStorage4.getItem("user-azalea");
      if (!savedBPID && foundComp.businessProfileID) {
        // encryptStorage4.setItem("user-azalea", foundComp.businessProfileID);
      }
    } catch (e) {
      console.error("Storage decrypt failed:", e);
      //   encryptStorage3.removeItem("user-azalea");
      //   encryptStorage4.removeItem("user-azalea");
    }
  }, [comps]);

  const handleclick = () => {
    encryptStorage1.removeItem("user-azalea");
    encryptStorage3.removeItem("user-azalea");
    encryptStorage4.removeItem("user-azalea");
    encryptStorage6.removeItem("comp-azalea");
    navigate("/", { replace: true });
  };
  const [active, setActive] = useState("C");

  useEffect(() => {
    const routeActiveKey = getActiveKeyForPath(location.pathname);
    if (routeActiveKey) {
      setActive(routeActiveKey);
      return;
    }

    if (location.state?.active) {
      setActive(location.state.active);
    }
  }, [location.pathname, location.state]);
  return (
    <div className="business-header-supper-container">
      <div className="header-main-container">
        <div className="header-content-container">
          <div className="header-icon-container">
            <HeaderIcon />
          </div>
          <div className="header-title-container">Business Hub</div>
        </div>
        <div className="navbar-profile-wrap" ref={dropdownRef}>
          <div
            className="navbar-picture"
            onClick={() => setnavbaropen((p) => !p)}
            style={{ cursor: "pointer" }}
            role="button"
            tabIndex={0}
            aria-expanded={navbaropen}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                setnavbaropen((p) => !p);
              }
            }}
          >
            {/* <img src="" /> */}
            <div className="azalea-picture">
              {compname || "Company"} <ArrowDownIcon className="arrow-icon" />
            </div>
          </div>

          {navbaropen && (
            <div className="navbar-dropdown">
              <div className="navbar-dropdown-header">
                <div className="navbar-dropdown-userinfo">
                  <div className="navbar-dropdown-name">
                    Choose your company
                  </div>
                </div>
              </div>

              <div className="navbar-dropdown-divider" />

              {comps?.map((comp, index) => (
                <button
                  key={comp?.companyID ?? index}
                  type="button"
                  className="navbar-dropdown-item"
                  onClick={() => {
                    encryptStorage3.setItem("user-azalea", comp.companyID);
                    encryptStorage4.setItem(
                      "user-azalea",
                      comp.businessProfileID,
                    );
                    window.location.reload();
                  }}
                >
                  <span className="navbar-dropdown-item-icon">
                    <SettingsIcon />
                  </span>

                  <span className="navbar-dropdown-item-text">
                    {comp?.companyName ?? "Account Settings"}
                  </span>
                </button>
              ))}
              <button
                type="button"
                className="navbar-dropdown-item"
                onClick={() => {
                  handleclick();
                }}
              >
                <span className="navbar-dropdown-item-icon">
                  <SettingsIcon />
                </span>

                <span className="navbar-dropdown-item-text">Log Out</span>
              </button>
            </div>
          )}
        </div>
        <div className="business-header-navigation-responsive">
          <div
            className="three-lines-icon"
            onClick={(e) => {
              e.stopPropagation();
              setopenNav((prev) => !prev);
            }}
          >
            <ThreeLinesMenuIcon />
            {openNav ? (
              <div
                className="navigation-drop-menu"
                ref={dropmenuRef}
                onClick={(e) => e.stopPropagation()}
              >
                <BusinessHubNavigation
                  mode="prod"
                  active={active}
                  onItemClick={() => setopenNav(false)}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BusinessHibHeader;
